import '@/index.css';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { DataCacheProvider } from '@/contexts/DataCache';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { Login } from '@/pages/Login';
import { Dashboard } from '@/pages/Dashboard';
import { POS } from '@/pages/POS';
import { Products } from '@/pages/Products';
import { Categories } from '@/pages/Categories';
import { Clients } from '@/pages/Clients';
import { Sellers } from '@/pages/Sellers';
import { Shipments } from '@/pages/Shipments';
import { CollectShipments } from '@/pages/CollectShipments';
import { Inventory } from '@/pages/Inventory';
import { Reports } from '@/pages/Reports';
import { SellerCommissions } from '@/pages/SellerCommissions';
import { Purchases } from '@/pages/Purchases';
import { Exits } from '@/pages/Exits';
import { Catalog } from '@/pages/Catalog';
import { Cuts } from '@/pages/Cuts';
import { CutsReport } from '@/pages/CutsReport';
import { Settings } from '@/pages/Settings';
import { Packages } from '@/pages/Packages';
import { Apartados } from '@/pages/Apartados';
import { SalesReport } from '@/pages/SalesReport';
import { MercadoLibre } from '@/pages/MercadoLibre';
import MLApiConfig from '@/pages/MLApiConfig';
import MLScanner from '@/pages/MLScanner';
import StockAudit from '@/pages/StockAudit';
import Transfers from '@/pages/Transfers';
import { ShippingCosts } from '@/pages/ShippingCosts';
import ShippingQuote from '@/pages/ShippingQuote';
import DelivererPortal from '@/pages/DelivererPortal';
import ActivePromos from '@/pages/ActivePromos';
import PublicCatalog from '@/pages/PublicCatalog';
import EditCatalog from '@/pages/EditCatalog';
import KoreanProducts from '@/pages/KoreanProducts';
import { KoreanProductsAdmin } from '@/pages/KoreanProductsAdmin';
import SellerPortal from '@/pages/SellerPortal';
import WholesalePortal from '@/pages/WholesalePortal';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <AuthProvider>
      <DataCacheProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/cotizador" element={<ShippingQuote />} />
            <Route path="/quote" element={<ShippingQuote />} />
            <Route path="/entregador" element={<DelivererPortal />} />
            <Route path="/deliverer" element={<DelivererPortal />} />
            <Route path="/ofertas" element={<ActivePromos />} />
            <Route path="/promos" element={<ActivePromos />} />
            <Route path="/catalogo" element={<PublicCatalog />} />
            <Route path="/edit" element={<EditCatalog />} />
            <Route path="/catalog" element={<PublicCatalog />} />
            <Route path="/coreanos" element={<KoreanProducts />} />
            <Route path="/korean" element={<KoreanProducts />} />
            <Route path="/coreanosenvios" element={<KoreanProducts variant="envios" />} />
            <Route path="/vendedor" element={<SellerPortal />} />
            <Route path="/seller" element={<SellerPortal />} />
            <Route path="/mayorista" element={<WholesalePortal />} />
            <Route path="/wholesale" element={<WholesalePortal />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pos"
            element={
              <ProtectedRoute>
                <POS />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            element={
              <ProtectedRoute>
                <Products />
              </ProtectedRoute>
            }
          />
          <Route
            path="/categories"
            element={
              <ProtectedRoute>
                <Categories />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clients"
            element={
              <ProtectedRoute>
                <Clients />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sellers"
            element={
              <ProtectedRoute>
                <Sellers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shipments"
            element={
              <ProtectedRoute>
                <Shipments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/collect-shipments"
            element={
              <ProtectedRoute>
                <CollectShipments />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory"
            element={
              <ProtectedRoute>
                <Inventory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/commissions"
            element={
              <ProtectedRoute>
                <SellerCommissions />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchases"
            element={
              <ProtectedRoute>
                <Purchases />
              </ProtectedRoute>
            }
          />
          <Route
            path="/exits"
            element={
              <ProtectedRoute>
                <Exits />
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalog"
            element={
              <ProtectedRoute>
                <Catalog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cuts"
            element={
              <ProtectedRoute>
                <Cuts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cuts/report"
            element={
              <ProtectedRoute>
                <CutsReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/packages"
            element={
              <ProtectedRoute>
                <Packages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/productos-coreanos"
            element={
              <ProtectedRoute>
                <KoreanProductsAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shipping-costs"
            element={
              <ProtectedRoute>
                <ShippingCosts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales-report"
            element={
              <ProtectedRoute>
                <SalesReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/apartados"
            element={
              <ProtectedRoute>
                <Apartados />
              </ProtectedRoute>
            }
          />
          <Route
            path="/mercado-libre"
            element={
              <ProtectedRoute>
                <MercadoLibre />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ml-api"
            element={
              <ProtectedRoute>
                <MLApiConfig />
              </ProtectedRoute>
            }
          />
          <Route path="/ml-scanner" element={<MLScanner />} />
          <Route path="/stock-audit" element={<ProtectedRoute><StockAudit /></ProtectedRoute>} />
          <Route path="/transferencias" element={<ProtectedRoute><Transfers /></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </DataCacheProvider>
    </AuthProvider>
  );
}

export default App;
